import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initializeAuth } from '@/Auth';

// Initialize authentication system with automatic token refresh
initializeAuth();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(<App />);
